import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { Layout } from '../views/Layout'
import { AuthConsumer } from '../contexts/AuthContext';
import { Loading } from '../components';

const UnAuthorizedOperation = (prop, setUnAuthroizedOperation) => {
    if(prop.history.action==="POP"){
        const path = prop.location.pathname === "/" ? null : prop.location.pathname;
        const search = prop.location.search;
        const params = {};
        const paramArray = search.replace('?', '').split('&');
        Object.keys(paramArray).forEach((key) => {
            const keyValue = paramArray[key].split('=');
            if (keyValue.length === 2)
                params[keyValue[0]] = keyValue[1];
        });
    
        setUnAuthroizedOperation(path, params, prop);
    }
  
    return <Redirect to="/login" />
}

export const AuthRoute = ({ component: Component, ...rest }) => (
    <AuthConsumer>
        {({ isAuth, checkAuth, setUnAuthroizedOperation }) => (
            checkAuth ?

                <Route
                    render={props =>
                        isAuth ?
                            <Layout topbar="true" footer="true" sidebar="true">
                                <Component {...props} />
                            </Layout>
                            :
                            UnAuthorizedOperation(props, setUnAuthroizedOperation)
                    }
                    {...rest}
                />
                : <Loading />
        )}
    </AuthConsumer>
);

